export default "__VITE_ASSET__BwVU5tX8__"